import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function AUPPage() {
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();

  const handleAccept = () => {
    if (!accepted) {
      alert("You must accept the Acceptable Use Policy to continue.");
      return;
    }

    localStorage.setItem("aupAccepted", "true");

    const role = localStorage.getItem("role");

    if (role === "super_admin") {
      navigate("/dashboard");
    } else {
      navigate("/client-dashboard");
    }
  };

  return (
    <div className="aup-page">
      <div className="aup-card">
        <h2>Acceptable Use Policy</h2>

        <p>
          By using the Wireless Press Lockdown Console, you agree to use this
          platform only for authorized administrative, monitoring, and device
          management purposes.
        </p>

        <p>
          Unauthorized access, misuse of managed devices, attempts to bypass
          controls, or use of this platform outside approved business, school,
          ministry, or organizational operations is prohibited.
        </p>

        <p>
          All actions may be logged for operational, security, and compliance
          purposes.
        </p>

        <label className="checkbox-row">
          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
          />
          I have read and agree to the Acceptable Use Policy.
        </label>

        <button className="primary-button" onClick={handleAccept}>
          Accept and Continue
        </button>
      </div>
    </div>
  );
}

export default AUPPage;